import React, { useRef, useState } from "react";
import { useBreakpoints } from "../../hooks/useBreakpoints";

const AppCarousel = ({ children, className }) => {
  const [items, setItems] = useState(
    React.Children.map(children, (child) => child)
  );
  const carouselRef = useRef(null);
  const { lg } = useBreakpoints();
  let debounceId = null;

  function onScroll() {
    clearTimeout(debounceId);
    debounceId = setTimeout(() => {
      setItems((prev) => [
        ...prev,
        ...React.Children.map(children, (child) => child),
      ]);
    }, 500);
  }

  function next() {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({
        left: carouselRef.current.clientWidth,
        behavior: "smooth",
      });
    }
  }

  function prev() {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({
        left: -carouselRef.current.clientWidth,
        behavior: "smooth",
      });
    }
  }

  return (
    <div
      className={`overflow-hidden relative w-full group/carousel ${className}`}
    >
      {lg && (
        <div className="w-0 h-0">
          <div className="absolute z-10 top-0 left-0 translate-x-0 grid place-items-center w-16 h-full bg-arrow-carousel with-transition">
            <button onClick={prev} className="p-3 text-white text-xl">
              <i
                className="iconify"
                data-icon="material-symbols:arrow-back-ios-rounded"
              />
            </button>
          </div>
          <div className="absolute z-10 top-0 right-0 translate-x-0 grid place-items-center w-16 h-full bg-arrow-carousel rotate-180 with-transition">
            <button onClick={next} className="p-3 text-white text-xl">
              <i
                className="iconify"
                data-icon="material-symbols:arrow-back-ios-rounded"
              />
            </button>
          </div>
        </div>
      )}
      <div
        ref={carouselRef}
        id="carousel"
        onScroll={onScroll}
        className="app-carousel flex overflow-auto w-full snap-x snap-mandatory"
      >
        {items.map((item, index) => (
          <div
            key={index}
            className="app-carousel__card flex-grow-0 flex-shrink-0 flex justify-center min-w-min snap-center"
          >
            {item}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AppCarousel;
